<!-- 展商报名-主板人员卡片 -->
<template>
  <div class="interactor-card">
    <div class="interactor-header-img">
      <van-image 
      round
      width="60" 
      height="60" 
      fit="cover"
      :src="item.headImage" />
    </div>
    <div class="interactor-content">
      <div class="interactor-name">{{$tools.fieldProtaction(item.name, '--') }}</div>
      <div class="interactor-info">
        <div>
          <span>
            <span class="iconfont icon-show_dianhua"></span>
            <span class="interactor-info-text">{{$tools.fieldProtaction(item.mobile, '--')}}</span>
          </span>
          <span class="interactor-l-24">
            <i class="iconfont icon-show_chuanzhen"></i>
            <span class="interactor-info-text">{{$tools.fieldProtaction(item.telephone, '--')}}</span>
          </span>
        </div>
        <div>
          <i class="iconfont icon-youjian"></i>
          <span class="interactor-info-text">{{$tools.fieldProtaction(item.email, '--')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  props: {
    languageType: {
      default: '',
      type: String
    },
    item: {
      default: function () {
        return {
          id: '',
          name: '',
          enName: '',
          mobile: '',
          exhibitionId: '',
          languageType: '',
          headImage: '',
          email: '',
          telephone: ''
        }
      },
      type: Object
    }
  },
  components: {},
  data () {
    // 这里存放数据
    return {}
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.interactor-card {
  margin: 8px 15px 0px 15px;
  height: 152px;
  background:rgba(255,255,255,1);
  border-radius:10px;
  display: flex;
  padding: 15px;
  position: relative;
}
.interactor-header-img {
  margin-top: 45px;
}
.interactor-content {
  flex: 1;
  margin-left: 15px;
}
.interactor-name {
  margin-top: 32px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:200;
  color:#140F26;
  line-height:18px;
  word-break:break-all;
  /* margin-bottom: 30px; */
}
.iconfont {
  font-size:17px;
  font-style:normal;
  color:#6E7580;
  vertical-align: middle;
}
.interactor-info {
  position: absolute;
  bottom: 32px;
}
.interactor-info-text {
  font-size:11px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:200;
  color:#6E7580;
  line-height:15px;
  margin-left: 4px;
}
.interactor-l-24 {
  margin-left: 12px;
}
</style>
